import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface Folder3IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const Folder3Icon = ({ className, ...props }: Folder3IconProps) => (
  <svg
    className={cn("text-[#6C8FD4]", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.75 19.4004C22.7498 20.1457 22.1457 20.7498 21.4004 20.75H2.59961C1.85433 20.7498 1.25021 20.1457 1.25 19.4004V10.6045H22.75V19.4004ZM8.77832 3.25C9.10043 3.25007 9.41166 3.36559 9.65625 3.5752L12.7773 6.25H21.4004C22.1457 6.25021 22.7498 6.85433 22.75 7.59961V9.60449H1.25V4.59961C1.25021 3.85433 1.85433 3.25021 2.59961 3.25H8.77832Z"
      fill="currentColor"
    />
  </svg>
);

export default Folder3Icon;
